<template lang="pug">
	.insertion-editor--used-services-context-menu.used-services-context-menu
		template(v-if="!hideUI && editorContextMenuItems.length")
			.web-service-param-button.flex-row.space.align-center.justify(@click="showMenuButton", :id="`button_${id}`", :class="{ associated: associatedTemplateField }")
				fas(icon="link", size="xs")
			ContextMenu(ref="menuButton", :items="editorContextMenuItems", @item-click="onItemClick", :target="`#button_${id}`", cssClass="insertion-editor--context-menu")
				template(v-slot:service="{ data }")
					.service.navigation-item(:style="{ '--imageUrl': `url('${data.imageUrl}')` }", :title="data.text")
						.item.flex-row.align-center.center.justify.space-medium
							.flex-row.flex-1.space.align-center
								.image-holder
									.image
								.fixed-width.wrap {{data.text}}
							fas(icon="angle-right", size="xs")
				template(v-slot:output="{ data }")
					.web-service-param-output.output(:title="data.text", :class="{ 'associated': data.templateField && data.templateField.id == associatedTemplateField }")
						.flex-row.justify.align-center.space.align-center
							fas(:icon="data.icon || 'caret-right'", size="xs")
							.flex-1
								.fixed-width.wrap {{data.text}}
				template(v-slot:loader)
					.output
						Loader(:text="$tCaption('Loading', '@actions') + '..'")
				template(v-slot:header="{ data }")
					.output
						.font-tiny.upper.grey {{data.text}}
		ContextMenu(v-if="target", ref="menu", :items="editorContextMenuItems", @item-click="onItemClick", :target="target", cssClass="insertion-editor--context-menu")
			template(v-slot:service="{ data }")
				.service.navigation-item(:style="{ '--imageUrl': `url('${data.imageUrl}')` }", :title="data.text")
					.item.flex-row.align-center.center.justify.space-medium
						.flex-row.flex-1.space.align-center
							.image-holder
								.image
							.fixed-width.wrap {{data.text}}
						fas(icon="angle-right", size="xs")
			template(v-slot:output="{ data }")
				.output(:title="data.text")
					.flex-row.justify.align-center.space.align-center
						fas(icon="caret-right", size="xs")
						.flex-1
							.fixed-width.wrap {{data.text}}
			template(v-slot:loader)
				.output
					Loader(:text="$tCaption('Loading', '@actions') + '..'")
			template(v-slot:header="{ data }")
				.output
					.font-small.upper.grey {{data.text}}
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import ContextMenu from 'app-core/ContextMenu.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'insertion.UsedServicesContextMenu',
		name: 'insertion-editor--used-services-context-menu',
		components: { Loader, ContextMenu, DxButton },
		props: ['target', 'serviceIds', 'servicesTextSource', 'templateFields', 'hideUI', 'editingAreaResolver', 'associatedTemplateField', 'excludeServicesIds', 'forceTemplateFields', 'customContextMenuItems'],
		data() {
			return {
				webServicesMenuItems: [],
				isLoading: false,
				id: this.$Data.uuid()
			};
		},
		computed: {
			editorContextMenuItems() {
				return this.isLoading ? [{ template: 'loader' }] : [
					...this.combinedItems.templateFields,
					...this.combinedItems.customContextMenuItems,
					...this.webServicesMenuItems,
				];
			},
			combinedItems() {
				const services = this.webServicesMenuItems;
				const templateFields = (!this.templateFields?.length && !this.forceTemplateFields ? [] : [
					{	
						text: this.$tCaption('Template fields'),
						template: 'service',
						__type: 'templateFields',
						imageUrl: `${window.origin}/${require('assets/row.png')}`,
						items: this.templateFields.map(f => ({
							text: f.description,
							template: 'output',
							templateField: f,
							icon: 'f',
							insertValue: `[!${f.id}]`
						}))
					}
				]);
				return {
					services,
					templateFields,
					customContextMenuItems: this.customContextMenuItems || [],
					all: [
						...services,
						...templateFields,
						...(this.customContextMenuItems || [])
					]
				}
			}
		},
		watch: {
			'serviceIds'() {
				this.load();
			},
			'servicesTextSource'() {
				this.load();
			},
			'editorContextMenuItems': {
				handler() {
					if (!this.isLoading) {
						this.$emit('menu-items-change', this.combinedItems);
					}
				},
				deep: true
			}
		},	
		mounted() {
			if (__DEBUG__)
				window.usedServicesContextMenu = this;
			this.isLoading = true;
			this.load();
		},
		destroyed() {
			delete this.$renderedServicesOids;
		},
		methods: {
			load() {
				this.buildMenu().finally(() => this.isLoading = false);
			},
			show() {
				if (this.$refs.menu)
					this.$refs.menu.show();
			},
			showMenuButton() {
				if (this.$refs.menuButton)
					this.$refs.menuButton.show();
			},
			onItemClick(e) {
				const insertValue = e?.itemData?.insertValue;
				const param = e?.itemData?.param;
				if (__DEBUG__)
					console.debug('On item click', { e, insertValue, param });
				if (insertValue) {
					this.insertText(insertValue, e?.itemData);
				}
				if (e?.itemData?.action) {
					e?.itemData?.action(e?.itemData);
				}
			},
			async buildMenu() {
				const services = (await this.$Data.getExternalServices(0, 9999)).Results;
				const items = [];

				const filteredServices = services.filter(f => this.serviceIds?.includes(f.Oid) || this.servicesTextSource?.indexOf(f.Oid) > -1).filter(f => !this.excludeServicesIds?.includes(f.Oid));

				if (this.$renderedServicesOids !== filteredServices.map(f => f.Oid).join(',')) {
					if (__DEBUG__)
						console.debug('buildMenu', { filteredServices, templateFields: this.templateFields, items, ids: this.serviceIds });
					if (filteredServices.length) {
						items.push(...filteredServices.filter(f => f?.JsonDefinition?.Outputs?.filter(f => !f.Status)?.length || f?.JsonDefinition?.Parameters?.filter(f => f.UserEditable || f.ComplexParameterId)?.length).map(service => ({
							service,
							text: service.Name,
							template: 'service',
							imageUrl: service.ImageUrl,
							items: [
								...((service.JsonDefinition?.Parameters || []).filter(f => f.UserEditable || f.ComplexParameterId).length ? [{ template: 'header', text: this.$tCaption('Parameters') }] : []),
								...(service.JsonDefinition?.Parameters || []).filter(f => f.UserEditable || f.ComplexParameterId).map(param => ({
									text: param.Caption || param.Name || param.Description,
									template: 'output',
									icon: 'p',
									param,
									service,
									insertValue: `[${param.Name}@params.${service.Code}]`
								})),
								...((service.JsonDefinition?.Outputs || []).filter(f => !f.Status).length ? [{ template: 'header', text: this.$tCaption('Outputs') }] : []),
								...(service.JsonDefinition?.Outputs || []).filter(f => !f.Status).map(param => ({
									text: param.Caption || param.Name || param.Description,
									template: 'output',
									param,
									service,
									insertValue: `[${param.Name}@outputs.${service.Code}]`
								}))
							]
						})));
					}
					this.webServicesMenuItems = items;
					this.$renderedServicesOids = filteredServices.map(f => f.Oid).join(',')
				}
			},
			insertText(text, item) {
				const area = this.editingAreaResolver && this.editingAreaResolver();
				if (!area) {
					this.$emit('change', text, item)
					return;
				}
				var startPos = area.selectionStart;
				var endPos = area.selectionEnd;
				this.$emit('change', area.value.substring(0, startPos)
					+ text
					+ area.value.substring(endPos, area.value.length), item);
			}
		}
	};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.insertion-editor--used-services-context-menu, .used-services-context-menu {
		.navigation-item {
			padding: 0px 2px 0px 2px !important;
			font-size: 14px;
			font-weight: 100;

			> .item {
				padding: 2px 8px 2px 2px;
				border-radius: 4px;
				background: rgb(250,250,250);
			}
			
			.image-holder {
				--size: 40px;
				width: var(--size);
				height: var(--size);
				min-width: var(--size);
				min-height: var(--size);
				border-radius: 4px;
				border: 2px solid rgb(241,241,241);
				background: #fff;

				.image {
					border-radius: 4px;
					width: 100%;
					height: 100%;
					background: var(--imageUrl);
					background-size: cover;
					background-position: center;
				}
			}
		}

		.category {
			.image-holder {
				--size: 40px;
			}
		}

		.dx-menu-item-expanded {
			.image {
				filter: brightness(1) grayscale(0);
			}
		}

		.service {
			font-size: 12px;
			.image-holder {
				--size: 30px;
			}
		}

		.output {
			font-size: 12px;
			font-weight: 100;
			padding: 4px 8px;
		}

		.dx-menu-items-container {
			padding: 2px 0px 0px !important;
			background: rgb(243,243,243);
			border-radius: 4px;
		}

		.dx-menu-item-expanded, .dx-menu-item-expanded.dx-state-focused, .dx-menu-item-expanded.dx-state-hover {
			background-color: transparent !important;
		}

		.dx-menu-item-expanded {
			> .navigation-item {
				> .item {
					background: $base-accent;
					color: $base-bg;
				}
			}
		}

		.limit-width {
			max-width: 150px;
		}

		.fixed-width {
			width: 150px;
		}

	}
</style>